import axios from "axios";
import { displayOrReactivateSmartbox } from "../display/displayOrReactivateSmartbox";


export const deleteCreditCard = async (functionParameters = {}) => {
    console.log("======= I got all these parameter ", functionParameters);

    // alert("Getting the details ");
    // return false;

    let { preloaderClass, cardId, smetioPresentationId, smartbox, textClass, model, uniqueValues, titleClass, subTitleClass, paragraphClass } = functionParameters;
    // const { smetioPresentationId } = uniqueValues;

    cardId = cardId || $(`.smetio-hidden-input-card-id-${smetioPresentationId}`).val();


    const content = `
        <h2>${window["smetioTexts"]["txt487"]} </h2>
    `;
    displayOrReactivateSmartbox({preloaderClass, smartbox, tilte: "txt485", content });

/*     if (smartbox.hasBeenRendered && smartbox.currentState !== "close") {
        return smartbox.reactivate();
    }else{
        smartbox.title = "txt485";
        let content = preloaderClass.render();

        smartbox.title = "txt485";
        smartbox.content = content;
        smartbox.onClose = () => { smartbox = null; };
        smartbox.render();
        smartbox.sidelize();
        preloaderClass.show();
        smartbox.render();

    }; */



    preloaderClass.show();

    // return false;

    const deleteCardUrl = `${window.apiEndPoint}/stripeRoute/deleteCreditCard/${window.userLanguage}`;

    await axios.post(deleteCardUrl, {  cardId, smetioPresentationId  }).then((response) => {
  
        let result = response.data;
        // const res = result.fallbackFunctionDetails ? result.msg : result;
        let msgType = result.error ? "danger" : "success";
        let msg = result.msg;
        window.smetioVisitor.showNotification({
            type: msgType,
            body: [{ message: msg }]
        });

        if (result.error) return false;


        $(`.${subTitleClass}`).html("");
        $(`.${paragraphClass}`).html("");
        $(`.smetio-data-presentation-info-on-hover-${smetioPresentationId}`).html("");
        $(`.smetio-data-presentation-menu-item-${smetioPresentationId}-deleteCard`).attr("data-smetio-is-visible", false);
        $(`.smetio-data-presentation-menu-item-${smetioPresentationId}-addCard`).attr("data-smetio-is-visible", true);
  
      }).catch((error) => {
  
        console.log("There is error in deleteCreditCard ",error);

        return window.smetioVisitor.showNotification({
            type: "danger",
            body: [{ message: "txt423" }]
        });

      }).finally(() => {
        preloaderClass.hide();
        smartbox.close();
      });
  


/* 
    const setupIntentUrl = `${window.apiEndPoint}/stripeRoute/deleteCreditCard/${window.userLanguage}`;

    const vitalDetails = await axios.get(setupIntentUrl, {}).then((response) => {

        const result = response.data;

        if (result.error) return window.smetioVisitor.showNotification({
            type: "danger",
            body: [{ message: result.msg }]
        });

        return result;

    }).catch((error) => {

        console.log(error);

        return window.smetioVisitor.showNotification({
            type: "danger",
            body: [{ message: "txt423" }]
        });

    }).finally(()=>{
        // preloaderClass.hide();
    });

    preloaderClass.hide();

 */


};
